import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./index.scss";

export default function Loading() {
  return (
    <div className="ps-cp-wrapper">
      <CircularProgress />
    </div>
  );
}
